export const MERGE_DROPDOWN_CHECK_ANNOTATION_LEVEL = {
  FAILURE: 'failure',
  NOTICE: 'notice',
  WARNING: 'warning',
} as const;

export type MergeDropdownCheckAnnotationLevel =
  (typeof MERGE_DROPDOWN_CHECK_ANNOTATION_LEVEL)[keyof typeof MERGE_DROPDOWN_CHECK_ANNOTATION_LEVEL];

/** Minimal check annotation shape consumed by merge dropdown rendering. */
export type MergeDropdownCheckAnnotation = {
  annotation_level?: MergeDropdownCheckAnnotationLevel | null;
  message: string;
};

export const MERGE_DROPDOWN_CHECK_STATUS = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
  PENDING: 'pending',
  QUEUED: 'queued',
  REQUESTED: 'requested',
  WAITING: 'waiting',
} as const;

export type MergeDropdownCheckStatus =
  (typeof MERGE_DROPDOWN_CHECK_STATUS)[keyof typeof MERGE_DROPDOWN_CHECK_STATUS];

export const MERGE_DROPDOWN_CHECK_CONCLUSION = {
  ACTION_REQUIRED: 'action_required',
  CANCELLED: 'cancelled',
  FAILURE: 'failure',
  NEUTRAL: 'neutral',
  SKIPPED: 'skipped',
  STALE: 'stale',
  STARTUP_FAILURE: 'startup_failure',
  SUCCESS: 'success',
  TIMED_OUT: 'timed_out',
} as const;

export type MergeDropdownCheckConclusion =
  (typeof MERGE_DROPDOWN_CHECK_CONCLUSION)[keyof typeof MERGE_DROPDOWN_CHECK_CONCLUSION];

/** Normalized check run payload used across merge dropdown check-section components. */
export type MergeDropdownCheckRun = {
  id: string | number;
  name: string;
  status: MergeDropdownCheckStatus;
  conclusion: MergeDropdownCheckConclusion | null;
  html_url?: string | null;
  output?: {
    summary?: string | null;
    text?: string | null;
  } | null;
  annotations?: MergeDropdownCheckAnnotation[];
};
